import moment from 'moment';
import React from 'react';
import { alertRef } from '../../App';
import DatePicker from '../../Components/DatePicker/DatePicker';
import { Button } from '../../Components/StyledComponents';
import './TempHoliday.scss';

const TempHoliday = ({ tempDayOffs, patchTempHoliday }) => {
    const [ tempHolidays, setTempHolidays ] = React.useState([]);//임시 휴무일 목록

    React.useEffect(() => {
        //data 를 datetime 으로 Converting
        if(typeof tempDayOffs !== 'undefined' ){
            for(let i=0; i < tempDayOffs.length; i++){
                setTempHolidays(old => 
                    [...old,
                        { StartDate : new Date(tempDayOffs[i].StartYear + '-' + tempDayOffs[i].StartMonth + '-' + tempDayOffs[i].StartDay), 
                        EndDate : new Date(tempDayOffs[i].EndYear + '-' + tempDayOffs[i].EndMonth + '-' + tempDayOffs[i].EndDay)
                    }])
            }
        }
    },[])

    //Index의 start date 변경
    const handleTempStart = (val,i) => {
        let arr = tempHolidays;

        arr[i].StartDate = val;

        setTempHolidays([...arr])
    }

    //Index의 end date 변경
    const handleTempEnd = (val,i) => {
        let arr = tempHolidays;

        arr[i].EndDate = val;

        setTempHolidays([...arr])
    }

    //Index의 date 삭제
    const removeTempHolidays = (i) => {
        let arr = tempHolidays;

        arr.splice(i,1)

        setTempHolidays([...arr])
    }

    //임시 휴무일 배열 추가
    const addTempHolidays = () => {
        if( tempHolidays.length > 0 && tempHolidays[tempHolidays.length - 1].StartDate === '' && tempHolidays[tempHolidays.length - 1].EndDate === '' ){
            alertRef.current.showAlert({ title : '이전 항목을 입력해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
            return;
        }

        setTempHolidays([...tempHolidays,{ StartDate : '', EndDate : ''}])
    }

    //임시 휴무일 설정
    const patch = () => {
        let arr = [];
        if(tempHolidays.length > 0){
            for(let i=0; i < tempHolidays.length; i++){
                arr.push({
                    StartYear : parseInt(moment(tempHolidays[i].StartDate).format('YYYY')),
                    StartMonth : parseInt(moment(tempHolidays[i].StartDate).format('MM')),
                    StartDay : parseInt(moment(tempHolidays[i].StartDate).format('DD')),
                    EndYear : parseInt(moment(tempHolidays[i].EndDate).format('YYYY')),
                    EndMonth : parseInt(moment(tempHolidays[i].EndDate).format('MM')),
                    EndDay : parseInt(moment(tempHolidays[i].EndDate).format('DD')),
                })
            }
        }

        patchTempHoliday(arr)
    }

    return (
        <div className='temp-holiday'>
            <p className='modal-title'>임시 휴일</p>
            {
                tempHolidays.map((data,i) => {
                    return(
                        <div className='row' style={{ marginBottom : 16 }} key={i}>
                          <DatePicker maxDate minDate={new Date()} value={tempHolidays[i].StartDate} onChange={(val) => handleTempStart(val,i)}  style={{ width : 151 }} />
                          <p className='modal-title' style={{ marginBottom : 0, marginLeft : 8, marginRight : 8 }}>부터</p>
                          <DatePicker maxDate minDate={tempHolidays[i].StartDate} value={tempHolidays[i].EndDate} onChange={(val) => handleTempEnd(val,i)}  style={{ width : 151 }} />
                          <p className='modal-title' style={{ marginBottom : 0, marginLeft : 8, marginRight : 8 }}>까지</p>
                          <Button variant="sub" onClick={()=> removeTempHolidays(i)} style={{ width : 28, height : 28, borderRadius : 100, boxSizing : 'border-box', padding : 0 }}>
                            <img src={require('../../aseets/icons/minus_pink.svg').default} style={{ width : 24, height : 24, marginTop : 2 }} />
                          </Button>
                        </div>
                    )
                })
            }
            <Button variant="sub" onClick={() => addTempHolidays()} small style={{ paddingLeft : 16, paddingRight : 16 }}>
                <div className='row'>
                    <img src={require('../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                    추가하기
                </div>
            </Button>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default TempHoliday;